core.filter('noData', ['$translate',
    function($translate) {
        return function(input) {
            if(!input) {
                return $translate.instant('T.DATA.NO_DATA');
            }
            return input;
        };
    }
]);